import Immutable from 'immutable';
import {
  PORTAL_FETCH_CATEGORIES_SUCCESS,
  PORTAL_FETCH_EVENTS_SUCCESS,
  PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS,
  PORTAL_FETCH_PROFILES_RISE_SUCCESS,
  PORTAL_SCROLL_PROFILES_RISE_REQUEST, PORTAL_SCROLL_PROFILES_RISE_SUCCESS,
  PORTAL_FETCH_COUPON_RECEIVED_REQUEST, PORTAL_FETCH_COUPON_RECEIVED_SUCCESS, PORTAL_FETCH_COUPON_RECEIVED_ERROR,
  PORTAL_FETCH_COUPON_RECOMMEND_REQUEST, PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS, PORTAL_FETCH_COUPON_RECOMMEND_ERROR,
  PORTAL_RECEIVE_COUPON, PORTAL_ADD_FRIEND, PORTAL_BLOCK_FRIEND,
  PORTAL_UPDATE_CATEGORY_MORE, PORTAL_UPDATE_COUPON_MORE
} from '../constants/ActionTypes';
import { convertReceivedCoupons } from '../utils/portalUtil';

const initialState = Immutable.Map();

const updateIsFriends = (profileId, isFriend) => {
  return (profiles) => {
    return profiles.map(profile => {
      if (profileId === profile.get('id')) {
        return profile.update('isFriend', currentIsFriend => isFriend);
      }
      return profile;
    });
  };
};

export default function portal(state = initialState, action) {
  switch (action.type) {
    case PORTAL_UPDATE_CATEGORY_MORE:
    {
      const { isOpen } = action;
      return state.update('isOpenCategory', isOpenCategory => isOpen);
    }
    case PORTAL_UPDATE_COUPON_MORE:
    {
      const { isOpen } = action;
      return state.update('isOpenCoupon', isOpenCoupon => isOpen);
    }
    case PORTAL_FETCH_CATEGORIES_SUCCESS:
    {
      const { result } = action;
      return state.merge(Immutable.fromJS({ categories: result || [] }));
    }
    case PORTAL_FETCH_EVENTS_SUCCESS:
    {
      const { result } = action;
      return state.merge(Immutable.fromJS({
        eventTop: result.top || [],
        eventMiddle: result.middle || {}
      }));
    }
    case PORTAL_FETCH_PROFILES_RECOMMEND_RANDOM_SUCCESS:
    {
      const { result } = action;
      return state.merge(Immutable.fromJS({ profileRecommends: result || [] }));
    }
    case PORTAL_FETCH_PROFILES_RISE_SUCCESS:
    {
      const { result } = action;
      return state.merge(Immutable.fromJS({
        profileRise: result.items || [],
        profileRiseUpdateDate: result.date || ''
      }));
    }
    case PORTAL_SCROLL_PROFILES_RISE_REQUEST:
    {
      return state.update('isRiseFetching', isRiseFetching => true);
    }
    case PORTAL_SCROLL_PROFILES_RISE_SUCCESS:
    {
      return state.update('isRiseFetching', isRiseFetching => false)
        .update('profileRiseRenderCount', profileRiseRenderCount => {
          const currentCount = !profileRiseRenderCount ? 20 :  profileRiseRenderCount;
          return currentCount + 20;
        });
    }
    case PORTAL_FETCH_COUPON_RECEIVED_REQUEST:
    {
      return state.merge(Immutable.fromJS({
        receivedCoupons: [],
        isFetchingCouponReceived: true
      }));
    }
    case PORTAL_FETCH_COUPON_RECEIVED_SUCCESS:
    {
      const { result } = action;
      return state.merge(Immutable.fromJS({
        receivedCoupons: convertReceivedCoupons(result),
        isFetchingCouponReceived: false
      }));
    }
    case PORTAL_FETCH_COUPON_RECEIVED_ERROR:
    {
      return state.merge(Immutable.fromJS({
        receivedCoupons: [],
        isFetchingCouponReceived: false
      }));
    }
    case PORTAL_FETCH_COUPON_RECOMMEND_REQUEST:
    {
      return state.update('isFetchingCouponRecommend', isFetching => true);
    }
    case PORTAL_FETCH_COUPON_RECOMMEND_SUCCESS:
    {
      const { result } = action;
      return state.update('recommendCoupons', recommendCoupons => (recommendCoupons || Immutable.List()).concat(Immutable.fromJS(result.items)))
        .merge(Immutable.fromJS({
          hasNextCoupon: result.hasNext,
          isFetchingCouponRecommend: false
        }));
    }
    case PORTAL_FETCH_COUPON_RECOMMEND_ERROR:
    {
      return state.merge(Immutable.fromJS({
        hasNextCoupon: false,
        isFetchingCouponRecommend: false
      }));
    }
    case PORTAL_RECEIVE_COUPON:
    {
      const { index } = action;
      return state.update('recommendCoupons', recommendCoupons => recommendCoupons.splice(index, 1));
    }
    case PORTAL_ADD_FRIEND:
    {
      const { profileId, reduxNames } = action;
      return reduxNames.reduce((a, b) => {
        if (typeof name === 'string') {
          return state.update(a, updateIsFriends(profileId, true)).update(b, updateIsFriends(profileId, true));
        } else {
          return a.update(a, updateIsFriends(profileId, true));
        }
      });
    }
    case PORTAL_BLOCK_FRIEND:
    {
      const { profileId, reduxNames } = action;
      return reduxNames.reduce((a, b) => {
        if (typeof name === 'string') {
          return state.update(a, updateIsFriends(profileId, false)).update(b, updateIsFriends(profileId, false));
        } else {
          return a.update(a, updateIsFriends(profileId, false));
        }
      });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/portal.js